export const DELETE_NEWS_REQUEST = 'DELETE_NEWS_REQUEST';
export const DELETE_NEWS_SUCCESS = 'DELETE_NEWS_SUCCESS';
export const DELETE_NEWS_FAILURE = 'DELETE_NEWS_FAILURE';
export const RESET_DELETE_NEWS_STATE = 'RESET_DELETE_NEWS_STATE';

export const deleteNewsRequest = (id) => ({
    type: DELETE_NEWS_REQUEST,
    payload: id,
});

export const deleteNewsSuccess = (id) => ({
    type: DELETE_NEWS_SUCCESS,
    payload: id,
});

export const deleteNewsFailure = (error) => ({
    type: DELETE_NEWS_FAILURE,
    payload: error,
});
